const textInputLabel = {
  group: '',
  queryType: 'textInputLabel',
  // nextQuery: 'inTextInput',
  type: 'key',
  options: []
}

// export const inTextInput = {
//   group: '',
//   queryType: 'inTextInput',
//   type: 'value',
//   options: []
// }

const advTextInputLabel = {
  group: '',
  queryType: 'advTextInputLabel',
  // nextQuery: 'inTextInput',
  type: 'key',
  options: []
}

const jsonRteTextLabel = {
  group: '',
  queryType: 'jsonRteTextLabel',
  // nextQuery: 'inTextInput',
  type: 'key',
  options: []
}

const customFieldJsonLabel = {
  group: '',
  queryType: 'customFieldJsonLabel',
  // nextQuery: 'inTextInput',
  type: 'key',
  options: []
}

// const customFieldTextLabel = {
//   group: '',
//   queryType: 'customFieldTextLabel',
//   // nextQuery: 'inTextInput',
//   type: 'key',
//   options: []
// }

// const customFieldNumberLabel = {
//   group: '',
//   queryType: 'customFieldNumberLabel',
//   // nextQuery: 'inNumber',
//   type: 'key',
//   options: []
// }

// const customFieldDateLabel = {
//   group: '',
//   queryType: 'customFieldDateLabel',
//   // nextQuery: 'inDate',
//   type: 'key',
//   options: []
// }

// const customFieldBooleanLabel = {
//   group: '',
//   queryType: 'customFieldBooleanLabel',
//   // nextQuery: 'inBoolean',
//   type: 'key',
//   options: []
// }

// const customFieldFileLabel = {
//   group: '',
//   queryType: 'customFieldFileLabel',
//   // nextQuery: 'inFile',
//   type: 'key',
//   options: []
// }

// export const customFieldReferenceLabel = {
//   group: '',
//   queryType: 'customFieldReferenceLabel',
//   // nextQuery: 'inReference',
//   type: 'key',
//   options: []
// }

const selectLabel = {
  group: '',
  queryType: 'selectLabel',
  // nextQuery: 'inSelect',
  type: 'key',
  options: []
}

export const inSelect = {
  group: '',
  queryType: 'inSelect',
  type: 'value',
  options: []
}

export const numberLabel = {
  group: '',
  queryType: 'numberLabel',
  // nextQuery: 'inNumber',
  type: 'key',
  options: []
}

// export const inNumber = {
//   group: '',
//   queryType: 'inNumber',
//   type: 'value',
//   options: []
// }

export const booleanLabel = {
  group: '',
  queryType: 'booleanLabel',
  // nextQuery: 'inBoolean',
  type: 'key',
  options: []
}

export const inBoolean = {
  group: '',
  queryType: 'booleanLabel',
  type: 'value',
  options: [
    { label: 'true', value: 'true' },
    { label: 'false', value: 'false' }
  ]
}

const dateLabel = {
  group: '',
  queryType: 'dateLabel',
  // nextQuery: 'inDate',
  type: 'key',
  options: []
}

export const fileLabel = {
  group: '',
  queryType: 'fileLabel',
  // nextQuery: 'inFile',
  type: 'key',
  options: []
}

export const inFile = {
  group: '',
  queryType: 'fileLabel',
  type: 'value',
  options: []
}

export const linkLabel = {
  group: '',
  queryType: 'linkLabel',
  // nextQuery: 'inTextInput',
  type: 'key',
  options: []
}

export const referenceLabel = {
  group: '',
  queryType: 'referenceLabel',
  // nextQuery: 'inReference',
  type: 'key',
  options: []
}

export const inReference = {
  group: '',
  queryType: 'referenceLabel',
  type: 'value',
  options: []
}

const getTopLevelIcons = (field: any): string => {
  const icons: any = {
    title: 'Title-Title Field',
    text: 'SingleLineText-Single Line Text Field',
    multitext: 'MultiLineText-Multi Line Text Field',
    rte: 'RichTextEditor-Rich Text Editor',
    jsonRte: 'JsonRichTextEditor-Json Rich Text Editor',
    markdown: 'Markdown-Markdown',
    select: 'Select-Select Field',
    number: 'Number-Number Field',
    boolean: 'Boolean-Boolean Field',
    isodate: 'Date-Date Field',
    file: 'File-File Field',
    reference: 'Reference-Reference Field',
    group: 'Group-Group',
    global_field: 'Global-Global Field',
    blocks: 'ModularBlocks-Modular Block',
    link: 'Link-Link',
    bullet: 'Bullet-Bullet',
    custom: 'Custom-Custom Field',
    tag: 'Tag-Tag',
    experience_container: 'ExperienceContainer-Experience Container',
    url: 'Url-Url',
    taxonomy: 'TaxonomySmall-Taxonomy'
  }

  if (field.uid == 'title') {
    return icons['title']
  }

  if (field.uid == 'tags') {
    return icons['tag']
  }

  if (field?.data_type === 'json' && field.field_metadata?.allow_json_rte) {
    return icons['jsonRte']
  }

  if (field.data_type == 'text') {
    if (field.uid == 'url' && field.$uid == 'url') {
      return icons['url']
    }
    if (field && field.field_metadata && field.field_metadata.multiline) {
      return icons['multitext']
    }
    if (field && field.field_metadata && field.field_metadata.allow_rich_text) {
      return icons['rte']
    }
    if (field && field.field_metadata && field.field_metadata.markdown) {
      return icons['markdown']
    }
    if (field && field.enum) {
      return icons['select']
    }
  }
  if (field.data_type === 'number') {
    if (field.enum) {
      return icons['select']
    }
  }
  if (field && field.field_metadata && field.field_metadata.extension) {
    return icons['custom']
  }

  if (!field.data_type) {
    return icons['blocks']
  }

  return icons[field.data_type]
}

const isMatchFound = (schemaObj = {}, searchTerm = '') => {
  try {
    if (searchTerm.length) {
      const keysToCheck = ['display_name', 'uid', 'title', 'description']
      const matchFound = keysToCheck.some((key) => {
        const value = schemaObj[key]
        return typeof value === 'string' && value.toLowerCase().includes(searchTerm.toLowerCase())
      })

      return matchFound
    }
    return false
  } catch (error) {
    return false
  }
}

export const getCtUserDefinedFields = (schema = [], userDefinedFields, parentUid, parentDisplayName, searchTerm) => {
  // console.log('🚀 ~ getCtUserDefinedFields ~ schema:', schema)
  schema.forEach((schemaObj) => {
    const matchResult = isMatchFound(schemaObj, searchTerm)
    let finalUid = parentUid ? parentUid + '.' + schemaObj.uid : schemaObj.uid
    let label = parentDisplayName ? parentDisplayName + ' / ' + schemaObj.display_name : schemaObj.display_name

    const field_metadata = schemaObj.field_metadata || {}

    const { markdown, allow_rich_text, multiline, allow_json_rte, extension } = field_metadata

    if (extension && schemaObj.data_type) {
      const supportedCustomFieldType = ['number', 'isodate', 'text', 'file', 'boolean']
      if (supportedCustomFieldType.includes(schemaObj.data_type)) {
        const fieldByDataType = {
          number: numberLabel,
          isodate: dateLabel,
          text: textInputLabel,
          file: fileLabel,
          boolean: booleanLabel
          // json: customFieldJsonLabel
        }

        const customFieldOption = [
          {
            icon: getTopLevelIcons(schemaObj),
            label: schemaObj.display_name,
            uid: schemaObj.uid,
            value: finalUid,
            info: parentUid ? label : `/ ${label}`,
            nestingLevel: label ? label.split('/').length - 1 : 0
          }
        ]
        userDefinedFields.push({
          ...fieldByDataType[schemaObj.data_type],
          options: customFieldOption,
          match: matchResult
        })
      } else if (schemaObj.data_type === 'json') {
        const customFieldOption = [
          {
            icon: getTopLevelIcons(schemaObj),
            label: schemaObj.display_name,
            // uid: schemaObj.uid,
            value: finalUid,
            info: parentUid ? label : `/ ${label}`,
            nestingLevel: label ? label.split('/').length - 1 : 0
          }
        ]
        userDefinedFields.push({
          ...customFieldJsonLabel,
          options: customFieldOption,
          match: matchResult
        })
      } else if (schemaObj.data_type === 'reference') {
        const customFieldOption = [
          {
            icon: getTopLevelIcons(schemaObj),
            label: schemaObj.display_name,
            // uid: schemaObj.uid,
            value: finalUid,
            valueOptions:
              typeof schemaObj.reference_to === 'string' ? [schemaObj.reference_to] : schemaObj.reference_to,
            info: parentUid ? label : `/ ${label}`,
            nestingLevel: label ? label.split('/').length - 1 : 0
          }
        ]
        userDefinedFields.push({
          ...referenceLabel,
          options: customFieldOption,
          match: matchResult
        })
      }
    } else if (schemaObj.data_type === 'json' && allow_json_rte) {
      const jsonRteOption = [
        {
          icon: getTopLevelIcons(schemaObj),
          label: schemaObj.display_name,
          // uid: schemaObj.uid,
          value: finalUid,
          info: parentUid ? label : `/ ${label}`,
          nestingLevel: label ? label.split('/').length - 1 : 0
        }
      ]
      userDefinedFields.push({
        ...jsonRteTextLabel,
        options: jsonRteOption,
        match: matchResult
      })
    } else if (schemaObj.data_type === 'text') {
      if (markdown || allow_rich_text || multiline) {
        const advTextInputOption = [
          {
            icon: getTopLevelIcons(schemaObj),
            label: schemaObj.display_name,
            // uid: schemaObj.uid,
            value: finalUid,
            info: parentUid ? label : `/ ${label}`,
            nestingLevel: label ? label.split('/').length - 1 : 0
          }
        ]

        userDefinedFields.push({
          ...advTextInputLabel,
          options: advTextInputOption,
          match: matchResult
        })
      } else if (
        schemaObj.display_type === 'dropdown' ||
        schemaObj.display_type === 'radio' ||
        schemaObj.display_type === 'checkbox'
      ) {
        let valueOptions = schemaObj.enum.choices.map((choice) => ({
          label: choice.value,
          value: choice.value
        }))
        let selectLabelOption = [
          {
            icon: getTopLevelIcons(schemaObj),
            label: schemaObj.display_name,
            // uid: schemaObj.uid,
            value: finalUid,
            valueOptions,
            info: parentUid ? label : `/ ${label}`,
            nestingLevel: label ? label.split('/').length - 1 : 0
          }
        ]
        const select = {
          ...selectLabel,
          options: selectLabelOption,
          match: matchResult
        }
        userDefinedFields.push(select)
      } else {
        const textInputOption = [
          {
            icon: getTopLevelIcons(schemaObj),
            label: schemaObj.display_name,
            // uid: schemaObj.uid,
            value: finalUid,
            info: parentUid ? label : `/ ${label}`,
            nestingLevel: label ? label.split('/').length - 1 : 0
          }
        ]
        userDefinedFields.push({ ...textInputLabel, options: textInputOption, match: matchResult })
      }
    } else if (schemaObj.data_type === 'number') {
      const numberOption = [
        {
          icon: getTopLevelIcons(schemaObj),
          label: schemaObj.display_name,
          // uid: schemaObj.uid,
          value: finalUid,
          info: parentUid ? label : `/ ${label}`,
          nestingLevel: label ? label.split('/').length - 1 : 0
        }
      ]
      userDefinedFields.push({ ...numberLabel, options: numberOption, match: matchResult })
    } else if (schemaObj.data_type === 'boolean') {
      const booleanOption = [
        {
          icon: getTopLevelIcons(schemaObj),
          label: schemaObj.display_name,
          // uid: schemaObj.uid,
          value: finalUid,
          info: parentUid ? label : `/ ${label}`,
          nestingLevel: label ? label.split('/').length - 1 : 0
        }
      ]
      userDefinedFields.push({ ...booleanLabel, options: booleanOption, match: matchResult })
    } else if (schemaObj.data_type === 'isodate') {
      const dateLabelOption = [
        {
          icon: getTopLevelIcons(schemaObj),
          label: schemaObj.display_name,
          // uid: schemaObj.uid,
          value: finalUid,
          info: parentUid ? label : `/ ${label}`,
          nestingLevel: label ? label.split('/').length - 1 : 0
        }
      ]
      userDefinedFields.push({ ...dateLabel, options: dateLabelOption, match: matchResult })
    } else if (schemaObj.data_type === 'file') {
      let fileLabelOption: any = [
        {
          icon: getTopLevelIcons(schemaObj),
          label: schemaObj.display_name,
          // uid: schemaObj.uid,
          value: finalUid,
          info: parentUid ? label : `/ ${label}`,
          nestingLevel: label ? label.split('/').length - 1 : 0
        }
      ]
      userDefinedFields.push({ ...fileLabel, options: fileLabelOption, match: matchResult })
    } else if (schemaObj.data_type === 'link') {
      const nestingLevel = label ? label.split('/').length - 1 : 0
      const linkLabelOption = [
        {
          label: 'Title',
          value: `${finalUid}.title`,
          info: parentUid ? label : `/ ${label}`,
          nestingLevel: nestingLevel + 1,
          icon: 'Title-Title Field'
        },
        {
          label: 'URL',
          value: `${finalUid}.href`,
          info: parentUid ? label : `/ ${label}`,
          nestingLevel: nestingLevel + 1,
          icon: 'Url-Url'
        }
      ]
      userDefinedFields.push({
        ...linkLabel,
        icon: getTopLevelIcons(schemaObj),
        group: schemaObj.display_name,
        options: linkLabelOption,
        nestingLevel,
        match: matchResult
      })
    } else if (schemaObj.data_type === 'reference') {
      const referenceLabelOption = [
        {
          icon: getTopLevelIcons(schemaObj),
          label: schemaObj.display_name,
          // uid: schemaObj.uid,
          value: finalUid,
          valueOptions: typeof schemaObj.reference_to === 'string' ? [schemaObj.reference_to] : schemaObj.reference_to,
          info: parentUid ? label : `/ ${label}`,
          nestingLevel: label ? label.split('/').length - 1 : 0
        }
      ]
      userDefinedFields.push({
        ...referenceLabel,
        options: referenceLabelOption,
        match: matchResult
      })
    } else if (schemaObj.data_type === 'group') {
      const parentGroup = {
        icon: getTopLevelIcons(schemaObj),
        group: schemaObj.display_name,
        options: [],
        nestingLevel: label ? label.split('/').length - 1 : 0
      }
      userDefinedFields.push(parentGroup)
      getCtUserDefinedFields(schemaObj.schema, userDefinedFields, finalUid, label, searchTerm)
    } else if (schemaObj.data_type === 'global_field') {
      const parentGroup = {
        icon: getTopLevelIcons(schemaObj),
        group: schemaObj.display_name,
        options: [],
        nestingLevel: label ? label.split('/').length - 1 : 0
      }
      userDefinedFields.push(parentGroup)
      getCtUserDefinedFields(schemaObj.schema, userDefinedFields, finalUid, label, searchTerm)
    } else if (schemaObj.data_type === 'blocks') {
      let blockUids = parentUid ? parentUid + '.' + schemaObj.uid : schemaObj.uid
      let blockLabel = parentDisplayName ? parentDisplayName + ' / ' + schemaObj.display_name : schemaObj.display_name

      const parentGroup = {
        icon: getTopLevelIcons(schemaObj),
        group: schemaObj.display_name,
        options: [],
        nestingLevel: label ? label.split('/').length - 1 : 0
      }
      userDefinedFields.push(parentGroup)

      schemaObj.blocks.forEach((block) => {
        let singleBlockUids = blockUids + '.' + block.uid
        let singleBlockLabel = blockLabel + ' / ' + block.title
        const parentGroup = {
          icon: getTopLevelIcons(schemaObj),
          group: block.title,
          options: [],
          nestingLevel: singleBlockLabel ? singleBlockLabel.split('/').length - 1 : 0
        }
        userDefinedFields.push(parentGroup)
        getCtUserDefinedFields(block.schema, userDefinedFields, singleBlockUids, singleBlockLabel, searchTerm)
      })
    }
  })

  return userDefinedFields
}
